'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleAddItemToCartError = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * @param error {String} The string we will be searching
 *
 * @returns {Object}
 */
var handleAddItemToCartError = exports.handleAddItemToCartError = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(error) {
    var errJson, status, description, alreadyInCart, addedMoreThanExists, allowedQuantity;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return error.json();

          case 2:
            errJson = _context.sent;
            status = errJson.status, description = errJson.description;
            alreadyInCart = description.slice(0, 4) === 'All ';
            addedMoreThanExists = description.slice(0, 18) === 'You can\'t add more';

            // We've tried adding to many of a quantity to the cart
            // We'll try and grab the amount we can add and add that

            if (!(status === 422)) {
              _context.next = 9;
              break;
            }

            allowedQuantity = 1;
            return _context.abrupt('return', {
              addedMoreThanExists: addedMoreThanExists,
              allowedQuantity: allowedQuantity,
              alreadyInCart: alreadyInCart,
              productName: findProductName(description, alreadyInCart)
            });

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function handleAddItemToCartError(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * This builds up the line item properties for use in Javascript
 *
 * @param formData {FormData} The form we will be traversing to find the properties
 *
 * @returns {Object}
 */

exports.buildProperties = buildProperties;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The description message comes back in the format
 * "You can't add more {title} to the cart" so we'll split on spaces
 * and join them back on every item after the 5th
 *
 * @param str {String} The string we will be searching
 * @param alreadyInCart {Boolean} If the error is because the product is already in the cart
 *
 * @returns {String}
 */
function findProductName(str, alreadyInCart) {
  var strSplitWithoutStart = alreadyInCart ? str.split(' ').slice(2).join(' ') : str.split(' ').slice(4).join(' ');

  return strSplitWithoutStart.replace(' to the cart.', '');
}function buildProperties(formData) {
  var propertyKeyValues = [].concat((0, _toConsumableArray3.default)(formData.entries())).filter(function (_ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return key.includes('properties[') && value !== '';
  });

  function propertyReducer(properties, _ref4) {
    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    var strippedKey = key.replace('properties[', '').slice(0, -1);

    return (0, _assign2.default)({}, properties, (0, _defineProperty3.default)({}, strippedKey, value));
  }

  return propertyKeyValues.reduce(propertyReducer, {});
}